//TODO This component needs to be refactored to modern standards
import isEqual from 'lodash.isequal'
import { getDateTimeFormat } from 'i18n/utils'
import * as grs from 'grs'
const { setAutoRenew } = grs.actions
import { vehiclesSelector } from 'dashboard-vehicles/selectors'
import VehicleSelect from 'shared/components/VehicleSelect'
import featureToggles from 'shared/featureToggles'

import ConfirmationModal from './ConfirmationModal'
import Button from '@components/Button'

import * as actions from '../actions'
import {
    cancellationSelector,
    changeVehiclePendingSelector,
    reservationCreditCardInfoSelector,
    reservationWithStatusSelector,
} from '../selectors'
import ErrorMessage from '@components/ErrorMessage'
import { getPaymentMethod } from './helpers'
import { CARD } from './constants'

const statusMapping = {
    [grs.constants.STATUS_ACTIVE]: 'dashboard.label.active',
    [grs.constants.STATUS_PASSED]: 'dashboard.label.passed',
}

const translationFromStatus = status => statusMapping[status] || 'dashboard.reservation.unknown'

const DateTime = ({ fromDate, toDate, promptAutoRenew, autoRenew, setAutoRenewPending, onChange }) => (
    <div className="detail time col">
        <p>
            <T>label.parking.start</T>
            {` ${fromDate.format(getDateTimeFormat())}`}
        </p>
        <p>
            <T>label.parking.end</T>
            {` ${toDate.format(getDateTimeFormat())}`}
        </p>
        {promptAutoRenew && (
            <div className="form-check">
                <label className="form-check-label">
                    {setAutoRenewPending === true ? (
                        <div className="spinner" />
                    ) : (
                        <input type="checkbox" className="form-check-input" checked={autoRenew} onChange={onChange} />
                    )}
                    &nbsp; <T>basket.auto.renew.label</T>
                </label>
            </div>
        )}
    </div>
)

class ReservationDetails extends Component {
    constructor(props) {
        super(props)

        this.onAutoRenewChange = this.onAutoRenewChange.bind(this)
        this.onCancelReservation = this.onCancelReservation.bind(this)
        this.onCloseModal = this.onCloseModal.bind(this)
        this.onVehicleSelected = this.onVehicleSelected.bind(this)
    }

    UNSAFE_componentWillMount() {
        const { getReservationCancelAmendPolicy, reservation } = this.props
        const { reservationId } = reservation

        getReservationCancelAmendPolicy(reservationId)
    }

    onAutoRenewChange(event) {
        const { reservation, setAutoRenew } = this.props

        setAutoRenew(reservation, event.target.checked)
    }

    onCancelReservation() {
        const { cancelReservation, reservation } = this.props
        const { reservationId } = reservation

        cancelReservation(reservationId)
    }

    onCloseModal() {
        const { closeCancellationModal } = this.props

        closeCancellationModal()
    }

    onVehicleSelected(selectedVehiclesInput) {
        const { reservation, vehicles, changeVehicle } = this.props
        const { reservationId, vehicles: reservationVehicles } = reservation
        const previousSelectedVehicles = vehicles.filter(vehicle =>
            reservationVehicles.find(item => item.tag === vehicle.tag)
        )

        const selectedVehicles = selectedVehiclesInput || []
        const selectedVehicleArray = selectedVehicles instanceof Array ? selectedVehicles : [selectedVehicles]

        if (!isEqual(previousSelectedVehicles, selectedVehicleArray)) changeVehicle(reservationId, selectedVehicleArray)
    }

    render() {
        const {
            reservation,
            setAutoRenewPending,
            onClose,
            confirmCancelReservation,
            cancellation,
            reservationCancelAmendPolicyPending,
            cancelReservationPending,
            vehicles,
            changeVehiclePending,
            creditCardInfo,
            translate: t,
        } = this.props
        const {
            location,
            fromDate,
            vehicles: reservationVehicles,
            toDate,
            status,
            isMonthlyPass,
            rateName,
            promptAutoRenew,
            autoRenew,
            reservationId,
            allowEditVehicle,
        } = reservation

        const {
            canCancel,
            isMultipleVehicle,
            numberOfVehicles,
            waitingForCancelConfirmation,
            error: cancellationError,
        } = cancellation

        const changeVehicleError = changeVehiclePending instanceof Error ? changeVehiclePending : null
        const selectedVehicles = vehicles.filter(vehicle =>
            reservationVehicles.find(item => item.tag.toLowerCase() === vehicle.tag.toLowerCase())
        )

        const paymentMethod = getPaymentMethod(reservation)

        const errors = []

        if (cancellationError) {
            errors.push(cancellationError)
        }

        if (changeVehicleError) {
            errors.push(changeVehicleError)
        }

        return (
            <div className="transaction-details-container">
                {reservationCancelAmendPolicyPending === true ? (
                    <div className="loading" />
                ) : (
                    <div>
                        <div className="text-center clearfix mb-5">
                            <div className="float-right">
                                <button className="close" onClick={onClose} />
                            </div>
                            <h2>{`${t(
                                isMonthlyPass ? 'dashboard.label.subscription' : 'dashboard.label.booking'
                            ).toUpperCase()}: ${rateName}`}</h2>
                        </div>
                        <div className="details-block">
                            <div className="row align-items-start no-gutters">
                                <div className="detail location col">{location}</div>
                                <DateTime
                                    fromDate={fromDate}
                                    toDate={toDate}
                                    promptAutoRenew={!featureToggles.isRenewSubscriptionAlways && promptAutoRenew}
                                    autoRenew={autoRenew}
                                    setAutoRenewPending={setAutoRenewPending}
                                    onChange={this.onAutoRenewChange}
                                />
                                <div className="detail status col">
                                    <T>{translationFromStatus(status)}</T>
                                    {canCancel && (
                                        <div className="button-panel">
                                            <Button btnStyle="outline" size="small" onClick={this.onCancelReservation}>
                                                <T>dashboard.label.cancel.reservation</T>
                                            </Button>
                                        </div>
                                    )}
                                </div>
                                <div className="detail vehicle col">
                                    {allowEditVehicle ? (
                                        <VehicleSelect
                                            selectedVehicles={selectedVehicles}
                                            onVehicleSelected={this.onVehicleSelected}
                                            isLoading={changeVehiclePending === true}
                                            allowMultiple={isMultipleVehicle}
                                            limit={numberOfVehicles}
                                        />
                                    ) : (
                                        selectedVehicles.map(vehicle => vehicle.tag).join(', ')
                                    )}
                                </div>
                                <div className="detail payment-method col">
                                    <T>{`dashboard.transaction.payment.${paymentMethod}`}</T>
                                    {paymentMethod === CARD && (
                                        <div className="payment-card-info">{creditCardInfo}</div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {errors.length > 0 && <ErrorMessage messages={errors} />}

                        {waitingForCancelConfirmation && (
                            <ConfirmationModal
                                reservationId={reservationId}
                                cancellationData={cancellation}
                                confirm={confirmCancelReservation}
                                cancelReservationPending={cancelReservationPending}
                                cancelAmendPolicyReservationPending={reservationCancelAmendPolicyPending}
                                closeModal={this.onCloseModal}
                            />
                        )}
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = createStructuredSelector({
    reservation: reservationWithStatusSelector,
    setAutoRenewPending: grs.selectors.setAutoRenewPendingSelector,
    cancellation: cancellationSelector,
    reservationCancelAmendPolicyPending: grs.selectors.reservationCancelAmendPolicyPendingSelector,
    cancelReservationPending: grs.selectors.cancelReservationPendingSelector,
    vehicles: vehiclesSelector,
    changeVehiclePending: changeVehiclePendingSelector,
    creditCardInfo: reservationCreditCardInfoSelector,
})

const {
    cancelReservation,
    confirmCancelReservation,
    closeCancellationModal,
    changeVehicle,
    getReservationCancelAmendPolicy,
} = actions

const mapDispatchToProps = {
    setAutoRenew,
    getReservationCancelAmendPolicy,
    cancelReservation,
    confirmCancelReservation,
    closeCancellationModal,
    changeVehicle,
}

export default compose(withTranslate, connect(mapStateToProps, mapDispatchToProps))(ReservationDetails)
